module.exports = [{
      plugin: require('/home/ipidov/projects/thebalkanfella/client/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"config/typography.js"},
    },{
      plugin: require('/home/ipidov/projects/thebalkanfella/client/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-149418104-1"},
    },{
      plugin: require('/home/ipidov/projects/thebalkanfella/client/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
